import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'

export function useSaleLimit(id: FunnelStepId, shouldFetch?: boolean) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, { salesCount: number }>({
    method: RequestMethodsEnum.get,
  })

  const { data: saleLimitData } = useSWR(() => {
    if (!shouldFetch) return null
    return `${FUNNELS_API}/step/${id}/sales-count`
  }, fetcher)

  return { saleLimitData }
}
